<template>
    <div>
        <div class="row mb-3 align-items-center">
            <div class="col-auto">
                <div class="green-filter d-flex">
					<span  :disabled="dataOverlay" v-for="(item, index) in greenFilterMenu" :key="index" :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" @click="handlerStatisticsOutputDate(index, item.type)">
						{{ item.title }}
					</span>
                    <div class="input-group">
                        <input type="date" class="form-control start-input-date" v-model="period_start">
                        <input type="date" class="form-control finish-input-date" v-model="period_end">
                        <div class="input-group-append" id="button-addon4">
                            <button
                                :class="periodButtonActive ? 'btn btn-outline-secondary-period-input active' : 'btn btn-outline-secondary-period-input'"
                                type="button"
                                @click="getStatisticsData();clearActive();"
                                :disabled="dataOverlay"
                            >Период</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col" v-if="!isManager && !dataOverlay">
                <div class="float-right green-filter mr-0 d-flex">
                    <span class="m-0" @click="creator_user_id = ''">Все</span>
                </div>
            </div>
            <div class="col-md-2 form-group m-0" v-if="!isManager && !dataOverlay">
                <tsoft-select-user
                    id="optional_sales_manager_user_id"
                    :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager`"
                    :additionalGetParameter="isCelebrity ? '':'&byotdel=1'"
                    :needNullElement="true"
                    :selected="creator_user_id"
                    :needAllElement="true"
                    @set="setManagerStatistics"
                ></tsoft-select-user>
            </div>
            <div class="col text-right pb-2" v-if="isManager">
                <b-button
                    size="sm"
                    variant="reload"
                    id="context-menu-analytic"
                    class="mr-2"
                >
                    <b-icon icon="gear-wide" scale="1.5" aria-label="Settings"></b-icon>
                </b-button>
                <em style="font-size: 11px;">Курс валют: USD {{cbr.USD || '--'}}, EUR {{cbr.EUR || '--'}}, CNY {{cbr.CNY || '--'}}, TRY {{cbr.TRY || '--'}}, AMD {{cbr.AMD || '--'}}, AED {{cbr.AED || '--'}}</em>
            </div>
        </div>

        <b-popover
            target="context-menu-analytic"
            triggers="focus hover"
            :placement="$mq == 'sm' ? 'bottom' : 'left'"
        >
            <template #title>
                <div class="mt-2 text-uppercase text-secondary">Настройки</div>
            </template>

            <div style="margin-top: -10px;"><b>Блок с карточками</b></div>
            <div
                class="form-check"
                v-for="(menuItem, index) in settingsMenu.cards"
                :key="index"
                v-if="menuItem.label"
            >
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="`cards_checkbox_${index}`"
                    v-model="menuItem.value"
                >
                <label class="form-check-label" :for="`cards_checkbox_${index}`">
                    {{ menuItem.label }}
                </label>
            </div>
        </b-popover>

        <div class="row mb-3" v-if="!isManager">
            <div class="col text-right">
                <b-button
                    size="sm"
                    variant="reload"
                    id="context-menu-analytic"
                    class="mr-2"
                >
                    <b-icon icon="gear-wide" scale="1.5" aria-label="Settings"></b-icon>
                </b-button>
                <em style="font-size: 11px;">Курс валют: USD {{cbr.USD || '--'}}, EUR {{cbr.EUR || '--'}}, CNY {{cbr.CNY || '--'}}, TRY {{cbr.TRY || '--'}}, AMD {{cbr.AMD || '--'}}, AED {{cbr.AED || '--'}}</em>
            </div>
        </div>

        <b-overlay
            :show="dataOverlay"
            no-center
            spinner-variant="success"
        >
            <template #overlay>
                <div class="align-items-center position-absolute" style="top: 15%;left: 50%;">
                    <b-spinner variant="success" label="Загрузка..."></b-spinner>
                </div>
            </template>

            <tsoft-card-reports
                :largeCardsRowOne="largeCardsRowOne"
                :largeCardsRowTwo="largeCardsRowTwo"
                :suppliesAppends="suppliesAppendsForCards"
                :settingsMenu="settingsMenu"
                @showByIds="showByIds"
                :key="settingsMenu.updateCardsCount"
            />

            <template v-if="chartStatistics.length != 0">
                <div :class="isManager ? 'row mb-5' : 'row'">
                    <template v-if="loading">
                        <div class="col-md-6"><b-skeleton animation="throb" height="541px"></b-skeleton></div>
                        <div class="col-md-6"><b-skeleton animation="throb" height="541px"></b-skeleton></div>
                    </template>
                    <template v-else>
                        <div class="col-md-12" v-if="chartColumnData">
                            <h5 class="mt-3 mb-4">
                                Операционные показатели
                            </h5>

                            <div class="green-filter d-flex">
                                <span
                                    v-for="(item, index) in chartsColumnFilterMenu"
                                    :key="index"
                                    :id="item.type"
                                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`"
                                    @click="handlerChartColumnData(index, item.type)"
                                >
                                    {{ item.title }}
                                </span>
                                <span
                                    :class="`ml-auto ${chartByDayOperationalButton ? 'green-link active' : 'green-link'}`"
                                    @click="toggleToDayOperationalChart()"
                                >По дням</span>
                            </div>
                            <div class="chart-container mt-5" style="position: relative;">
                                <column-chart :chartData="chartColumnData" :options="optionsChartBars" :chart-id="'operationChart'"></column-chart>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="chartLineData">
                            <h5 class="mt-3 mb-4">
                                Финансовые показатели
                            </h5>

                            <div class="green-filter d-flex">
                                <span
                                    v-for="(item, index) in chartsLineFilterMenu"
                                    :key="index"
                                    :id="item.type"
                                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`"
                                    @click="handlerChartLineData(index, item.type)"
                                >
                                    {{ item.title }}
                                </span>

                                <span
                                    :class="`ml-auto ${chartByDayFinanceButton ? 'green-link active' : 'green-link'}  ${hideByDayButton ? 'hide-button' : ''}`"
                                    @click="toggleToDayFinancialChart()"
                                >По дням</span>
                            </div>

                            <div class="chart-container mt-5" style="position: relative;">
                                <curve-chart @click-label="calcTotalVisibleLines" :chartData="chartLineData" :options="optionsChartLineMoney" :chart-id="'financeChart'"></curve-chart>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="topChartLineData">
                            <h5 class="mt-3 mb-4">
                                ТОП компаний
                            </h5>

                            <div class="green-filter d-flex">
                                <span
                                    v-for="(item, index) in topChartsLineFilterMenu"
                                    :key="index"
                                    :id="item.type"
                                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`"
                                    @click="handlerTopChartLineData(index, item.type)"
                                >
                                    {{ item.title }}
                                </span>

                                <span
                                    :class="`ml-auto mr-3 ${chartPartnersButton ? 'green-link active' : 'green-link'}`"
                                    @click="toggleTopChartByPartner()"
                                >Партнеры</span>
                                <span
                                    :class="`mr-3 ${chartWithPartnersButton ? 'green-link active' : 'green-link'}`"
                                    @click="toggleTopChartByWithPartner()"
                                >Все</span>
                                <template v-if="!generatingUrlProcess && !generatedUrl">
                                    <span
                                        class="green-link active"
                                        @click="generateExcelList()"
                                    >Выгрузить в Excel</span>
                                </template>
                                <template v-if="generatingUrlProcess && !generatedUrl">
                                    <span
                                        class="green-link active"
                                    >Создание отчета<i class="fas fa-spinner fa-spin ml-1"></i></span>
                                </template>
                                <template v-if="!generatingUrlProcess && generatedUrl">
                                    <a
                                        class="green-link active"
                                        :href="generatedUrl"
                                    >Скачать отчет</a>
                                </template>
                            </div>

                            <div class="chart-container mt-5" style="position: relative;">
                                <curve-chart
                                    @sendLegend="setLegend"
                                    :chartData="topChartLineData"
                                    :options="topChartOptions"
                                    :chart-id="'companyTop'"></curve-chart>
                                <div class="legend-con">
                                    <span
                                        v-for="(item, index) in topLegendButtons"
                                        :key="index"
                                        :style="item.active ? `color: ${item.color}; border-color: ${item.color};`: ''"
                                        @click="changeTopChartByLegend(index)"
                                    >{{ item.label }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <div class="row mt-5" v-if="!isManager && managerRatingStatistics.items && managerRatingStatistics.items.length > 0">
                <div class="col">
                    <div class="row mb-3">
                        <div class="col">
                            <h5>
                                Рейтинг менеджеров
                            </h5>
                        </div>
                        <div class="col-2">
                            <b-form-checkbox
                                v-model="noNeedZero"
                                name="optional-need-zeros-check-button"
                                switch
                                :value="true"
                                :unchecked-value="false"
                            >
                                <b>Убрать нулевые</b>
                            </b-form-checkbox>
                        </div>
                        <div class="col-2" v-if="canSeeUserFilters()">
                            <b-form-select v-model="userFilterByOtdel" :options="optionsOfOtdel" size="sm"></b-form-select>
                        </div>
                    </div>
                    <template v-if="dataOverlay">
                        <b-skeleton-table
                        animation="throb"
                        :rows="9"
                        :columns="11"
                        :table-props="{ bordered: false, striped: false }"
                        ></b-skeleton-table>
                    </template>
                    <template v-else>
                        <b-table
                            hover
                            responsive
                            :items="filteringDataByGroupFilter"
                            :fields="managerRatingStatistics.fields"
                            foot-clone
                        >
                            <template v-slot:head()="scope">
                                <span style="color:#000;">{{ scope.label }}</span>
                            </template>
                            <template #cell()="data">
                                <template v-if="data.field.loading">
                                    <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                </template>
                                <template v-else>
                                    <template v-if="canClickOnNumberInTable(data.field.key) && data.value != 0">
                                        <div
                                            :class="tdColorist(data.field.key) + 'text-nowrap cursor-pointer'"
                                            @click="showByIdsWithPrepare(canClickOnNumberInTable(data.field.key), data.item.realIndex, `${data.field.label} / ${data.item.name}`)"
                                        ><span class="underline-dotted">{{data.value}}</span></div>
                                    </template>
                                    <template v-else>
                                        <div :class="tdColorist(data.field.key) + 'text-nowrap'">{{data.value}}</div>
                                    </template>
                                </template>
                            </template>
                            <template #cell(debt_of_buyers)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(debt_of_buyers_7_days)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(debt_to_suppliers)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(earnings)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(rentability)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(marginality)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(marginality_easy)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(profit)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(paid_to_suppliers)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(finance_bills)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #cell(finance_bills_to_suppliers)="data">
                                {{ data.value | toShortCurrency }}
                            </template>
                            <template #foot()="data">
                                <template v-if="data.column == 'id'">{{''}}</template>
                                <template v-else-if="data.column == 'name'"><b>Итоги:</b></template>
                                <template v-else>
                                    <template v-if="data.field.loading && data.field.loading == true">
                                        <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    </template>
                                    <template v-else>
                                        {{ sumByColumn(data.column) }}
                                    </template>
                                </template>
                            </template>
                        </b-table>
                    </template>
                </div>
            </div>
        </b-overlay>

        <tsoft-order-list
            v-if="orderList && orderList.length > 0"
            :openOrderList="openOrderList"
            :orderList="orderList"
            :label="orderListLabel"
            @closeOrderList="closeOrderList"
        >
        </tsoft-order-list>

        <tsoft-finance-list
            v-if="financeList && financeList.length > 0"
            :openFinanceList="openFinanceList"
            :financeList="financeList"
            :label="financeListLabel"
            :need-group="openFinanceGroupedByOrder"
            :cbr="cbr"
            :periodStart="period_start"
            :periodEnd="period_end"
            :to_manager_from_order="order_to_manager"
            @closeFinanceList="closeFinanceList"
        />

        <tsoft-documents-list
            v-if="documentsList && documentsList.length > 0"
            :openDocumentsList="openDocumentsList"
            :documentsList="documentsList"
            :label="documentsListLabel"
            @closeDocumentsList="closeDocumentsList"
        >
        </tsoft-documents-list>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import CardReports from "../components/reports/CardReports.vue";
    import CurveChart from "../components/charts/CurveChart.vue";
    import ColumnChart from "../components/charts/ColumnChart.vue";
    import OrderList from '../components/orders/OrderList'
    import FinanceList from '../components/finance/FinanceList'
    import DocumentsList from '../components/documents/DocumentsList'

    import {
        API_STATISTIC,
        API_TOP_COMPANIES_EXCEL_ENRICHMENT,
        API_ANALYTICS_NEW_LEADS,
        API_ANALYTICS_NEW_BIDS,
        API_ANALYTICS_BIDS_IN_WORK_PERIOD,
        API_ANALYTICS_BIDS_IN_WORK,
        API_ANALYTICS_BIDS_IN_CANCEL,
        API_ANALYTICS_NEW_SUPPLIES,
        API_ANALYTICS_SUPPLIES_IN_WORK,
        API_ANALYTICS_SUPPLIES_SUCCESS,
        API_ANALYTICS_SUPPLIES_FINALIZED,
        API_ANALYTICS_SUPPLIES_IN_CANCEL,
        API_ANALYTICS_DEBT_OF_BUYERS_7_DAYS
    } from "../constants";

    import {
        reportChartSettings,
        topCompaniesReportExport,
        routeGetParamChangeOnFly
    } from '../mixins'


    const initialChartData = () => ({
        labels: [],
        datasets: [
            {
                label: '',
                data: []
            }
        ]
    })

    const initialSuppliesAppendedData = () => ({
        'leads': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'bids': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'bids_in_work_period': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'bids_in_work': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'supplies': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'supplies_in_work': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'supplies_in_success': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'supplies_in_finalized': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'supplies_in_cancel': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        'bids_in_cancel': {
            'all_orders_count': '.',
            'all_orders_ids': []
        },
        // 'debt_of_buyers_7_days': {
        //     count: {},
        //     count_with_nds: {},
        //     ids: [],
        //     label: "",
        //     services: {},
        //     tooltip: "",
        //     type: "finance"
        // }
    })

    export default {
        components: {
            "tsoft-card-reports": CardReports,
            CurveChart,
            ColumnChart,
            "tsoft-order-list": OrderList,
            "tsoft-finance-list": FinanceList,
            "tsoft-documents-list": DocumentsList,
        },
        mixins: [
            reportChartSettings,
            topCompaniesReportExport,
            routeGetParamChangeOnFly
        ],
        data() {
            return {
                order_to_manager: null,
                dataOverlay: true,
                loading: false,
				period_start: '',
				period_end: '',
                periodButtonActive: false,
				creator_user_id: '',
                cbr: {},
                cardStatistics: null,           //Данные статистики для карточек
                chartStatistics: [],            //Данные статистики для графиков
                managerRatingStatistics: {      //Данные статистики для таблицы
                    items: [],
                    fields: [],
                },
                chartColumnData: {},
                chartLineData: {},
                topChartLineData: {},
				largeCardsRowOne: null,
				largeCardsRowTwo: null,
				greenFilterMenu: [
					{title: 'Сегодня', type: 'today', active: false},
					{title: 'Неделя', type: 'week', active: false},
					{title: 'Месяц', type: 'month', active: true},
					{title: 'Год', type: 'year', active: false}
				],
                chartsColumnFilterMenu: [
					{title: 'Лиды', type: 'leads', active: true},
					{title: 'Заявки', type: 'bids', active: false},
					{title: 'Договоры', type: 'dogovors', active: false},
					{title: 'Поставки', type: 'supplies', active: false}
				],
                chartsLineFilterMenu: [
                    {title: 'Выручка', type: 'earnings', active: true, byDay: true},
                    {title: 'Прибыль', type: 'profit', active: false, byDay: true},
                    {title: 'Реализация', type: 'finance_realization', active: false, byDay: true},
                    {title: 'Рентабельность', type: 'rentability', active: false, byDay: false},
                    {title: 'Маржа', type: 'marginality_easy', active: false, byDay: false},
                    {title: 'Маржинальность поставок', type: 'marginality', active: false, byDay: false},
                    {title: 'Задолженность покупателей', type: 'debt_of_buyers', active: false, byDay: true},
                    {title: 'Задолженность поставщикам', type: 'paid_to_suppliers', active: false, byDay: true}
                ],
                topChartsLineFilterMenu: [
                    {title: 'Заявки', type: 'top_bids', active: false},
                    {title: 'Поставки', type: 'top_supplies', active: false},
                    {title: 'Выручка', type: 'top_earnings', active: true},
                    {title: 'Задолженность покупателей', type: 'top_debt_buyers', active: false},
                ],
                topChartOptions: {},
                chartPartnersButton: false,
                chartWithPartnersButton: false,
                openOrderList: false,              // Open sidebar with Orders List
                orderList: [],                     // Order list for sidebar
                orderListLabel: '',                // Title of sidebar with data for order
                openFinanceList: false,            // Open sidebar with Finance List
                financeList: [],                   // Finance list for sidebar
                financeListLabel: '',              // Title of sidebar with data for finance
                openDocumentsList: false,          // Open sidebar with Documents List
                documentsList: [],                 // Documents list for sidebar
                documentsListLabel: '',            // Title of sidebar with data for Documents
                openFinanceGroupedByOrder: false,
                userFilterByOtdel: '',
                optionsOfOtdel: [
                    { value: 'all', text: 'Все менеджеры' },
                    { value: 'suppliers', text: 'Все менеджеры поставок' },
                    { value: 'sellers', text: 'Отдел продаж' },
                    { value: 'to_department', text: 'Отдел ТО' },
                    { value: 'ved_department', text: 'Отдел логистики' },
                    { value: 'bsz_department', text: 'БСЗ' },
                ],
                isManager: true,
                isCelebrity: false,
                noNeedZero: true,
                apendedNumbersForTable: {
                    'leads': {},
                    'bids': {},
                    'bids_in_work_period': {},
                    'bids_in_work': {},
                    'supplies': {},
                    'supplies_in_work': {},
                    'supplies_in_success': {},
                    'supplies_in_finalized': {},
                    'supplies_in_cancel': {},
                    'bids_in_cancel': {}
                },
                suppliesAppendsForCards: null,
                chartLegend: null,
                topLegendButtons: [],
                controlableChartForLegend: null,
                legendSetted: false,
                selectedFinanceChartType: 'profit',
                selectedFinanceChartIndex: 1,
                chartByDayFinanceButton: false,
                selectedOperationalChartType: 'bids',
                selectedOperationalChartIndex: 1,
                chartByDayOperationalButton: false,
                settingsMenu: {
                    cards: {
                        noNds: {
                            label: 'Отображать суммы без НДС',
                            value: true,
                        },
                    },
                    updateCardsCount: 0
                },
            };
        },
        watch: {
            largeCardsRowOne() {
                this.loading = false
            },
            creator_user_id() {
                this.getStatisticsData()
            },
            'settingsMenu.cards': {
                handler(setting) {
                    this.settingsMenu.updateCardsCount += 1
                },
                immediate: false,
                deep: true,
            },
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),
            hideByDayButton() {
                let hideButton = false
                this.chartsLineFilterMenu.forEach((item) => {
                    if (item.active == true && item.byDay == false) {
                        hideButton = true
                    }
                })

                return hideButton
            },
            visibleUsersDataForTable() {
                if (this.noNeedZero) {
                    return this.managerRatingStatistics.items.filter(item => {
                        let isOneNotNull = 0
                        for (let prop in item) {
                            if (prop != 'id'
                                && prop != 'fired'
                                && prop != 'realIndex'
                                && typeof item[prop] === 'number'
                                && item[prop] != 0) {
                                isOneNotNull++
                            }
                        }
                        if (isOneNotNull > 0) {
                            return item
                        }
                    })
                }
                return this.managerRatingStatistics.items
            },
            filteringDataByGroupFilter() {
                if (!this.isManager && !this.creator_user_id) {
                    return this.visibleUsersDataForTable.filter(item => {
                        if (this.userFilterByOtdel == 'sellers') {
                            return (item.role.includes("sales-manager") || item.role.includes("sales-head-manager"))
                        } else if (this.userFilterByOtdel == 'suppliers') {
                            return (!item.role.includes("sales-manager") && !item.role.includes("sales-head-manager"))
                        } else if (this.userFilterByOtdel == 'to_department') {
                            return (item.role.includes("TO-manager") || item.role.includes("TO-head-manager"))
                        } else if (this.userFilterByOtdel == 'ved_department') {
                            return (item.role.includes("logistics-manager") || item.role.includes("logistics-head-manager"))
                        } else if (this.userFilterByOtdel == 'bsz_department') {
                            return (item.role.includes("bsz-manager"))
                        } else {
                            return item
                        }
                    })
                }
                return this.visibleUsersDataForTable
            }
        },
        mounted() {
            if (this.currentUser.role.includes("administrator")
                || this.currentUser.role.includes("president")
                || this.currentUser.role.includes("accountant")
                || this.currentUser.role.includes("head-accountant")
                || this.currentUser.role.includes("TO-head-manager")
                || this.currentUser.role.includes("logistics-head-manager")
                || this.currentUser.role.includes("sales-head-manager")) {
                this.isManager = false
            }
            if (this.currentUser.role.includes("administrator")
                || this.currentUser.role.includes("president")
                || this.currentUser.role.includes("accountant")
                || this.currentUser.role.includes("head-accountant")) {
                this.isCelebrity = true
            }

			let yearPeriod = document.querySelector('.active')
			yearPeriod.click()

            this.setDefaultDatesAndLoadData()
        },
        methods: {
            calcTotalVisibleLines(e) {
              let chartData = e.ci.data
              const activeLines = chartData.datasets.map(el => {
                if ( el._meta[Object.keys(el._meta)].hidden === null && el.label !== "Итого" ) {
                  return el
                } else {
                  return {
                    ...el,
                    data: Array(chartData.labels.length).fill(0)
                  }
                }
              })
              chartData.datasets.forEach((el, index) => {
                if (el.label === "Итого") {
                 chartData.datasets[index] = this.chartLineWithTotal({labels: chartData.labels, datasets: activeLines}, chartData.labels.length)
                }
              })
            },

            chartLineWithTotal(charts) {
              let newArr = charts.datasets;
              let valueDataset = newArr.map(el => el.data)
              let newDataset = Array(charts.labels.length).fill([])
              let resucedArr = newArr.reduce((acc) => {
                acc.data =
                  newDataset.map((el, index) => {
                    return valueDataset.map(child => child[index]).reduce((partialSum, a) => partialSum + a, 0)
                  })
                return acc
              }, {
                    backgroundColor: "transparent",
                    borderColor: "#f66d9b",
                    borderWidth: 1.8,
                    label: "Итого",
                    data: [],
                    ids: Array(charts.labels.length).fill([]),
                    data_unique_order_count: Array(charts.labels.length).fill(0),
                    lineTension: 0,
                    pointBorderWidth: 5,
                    pointHoverBackgroundColor: "#000000"
                  }
              )
              return resucedArr
            },
            setDefaultDatesAndLoadData() {
                if (this.$route.query.period_start) {
                    this.period_start = this.$route.query.period_start

                    if (this.$route.query.period_end) {
                        this.period_end = this.$route.query.period_end
                    }

                    this.getStatisticsData();
                } else {
                    this.handlerStatisticsOutputDate(2, 'month')
                }

                this.suppliesAppendsForCards = initialSuppliesAppendedData()
            },
            setLegend(elements, chart) {
                if (!this.legendSetted && elements && Array.isArray(elements) && elements.length > 0) {
                    this.legendSetted = true
                    this.topLegendButtons.splice(0)
                    elements.forEach((element, index) => {
                        this.topLegendButtons.push(element)
                    })
                    this.controlableChartForLegend = chart
                }
            },
            setManagerStatistics(value) {
                this.creator_user_id = value
            },
            changeTopChartByLegend(activeIndex) {
                this.$nextTick(function () {
                    if (activeIndex == 0) {
                        this.topLegendButtons[0].active = true
                        this.topLegendButtons.forEach((item, index) => {
                            item.active = true
                            if (index != 0) {
                                this.controlableChartForLegend.data.datasets[index - 1].hidden = false
                            }
                        })
                    } else {
                        this.topLegendButtons[0].active = false

                        this.topLegendButtons.forEach((item, index) => {
                            if (index != 0) {
                                this.topLegendButtons[index].active = false
                                // item.active = false
                                this.controlableChartForLegend.data.datasets[index - 1].hidden = true
                                if (activeIndex == index) {
                                    this.topLegendButtons[index].active = true
                                    this.controlableChartForLegend.data.datasets[index - 1].hidden = false
                                }
                            }
                        })
                    }
                    this.controlableChartForLegend.update()
                })
            },
            handlerChartColumnData(activeIndex, type) {
                this.chartsColumnFilterMenu.forEach((item, index) => {
                    item.active = false
                    if (activeIndex == index) {
                        item.active = true
                        this.selectedOperationalChartType = type
                        this.selectedOperationalChartIndex = activeIndex
                        this.chartColumnData = initialChartData()
                        this.$nextTick(function () {
                            this.chartColumnData = Object.assign({}, this.chartStatistics[type + (this.chartByDayOperationalButton ? '_day':'')])
                        })
                    }
                })
            },
            toggleToDayOperationalChart() {
                this.chartByDayOperationalButton = !this.chartByDayOperationalButton
                this.handlerChartColumnData(this.selectedOperationalChartIndex, this.selectedOperationalChartType)
            },
            handlerChartLineData(activeIndex, type) {
                this.chartsLineFilterMenu.forEach((item, index) => {
                    item.active = false
                    if (activeIndex == index) {
                        item.active = true
                        this.selectedFinanceChartType = type
                        this.selectedFinanceChartIndex = activeIndex
                        this.chartLineData = initialChartData()
                        this.$nextTick(function () {

                          let data = this.chartStatistics[this.selectedFinanceChartType + (this.chartByDayFinanceButton ? '_day' : '')]
                          this.chartLineData = {
                              labels: data.labels,
                              datasets: [...data.datasets, this.chartLineWithTotal(data)]
                          }
                        })
                    }
                })
            },
            toggleToDayFinancialChart() {
                this.chartByDayFinanceButton = !this.chartByDayFinanceButton
                this.handlerChartLineData(this.selectedFinanceChartIndex, this.selectedFinanceChartType)
            },
            handlerTopChartLineData(activeIndex, type) {
                this.selectedTopTypeParent.index = activeIndex
                this.selectedTopTypeParent.type = type

                this.topChartsLineFilterMenu.forEach((item, index) => {
                    item.active = false
                    if (activeIndex == index) {
                        item.active = true
                        this.topChartLineData = initialChartData()
                        this.$nextTick(function () {
                            setTimeout(() => {
                                this.legendSetted = false
                                this.generatedUrl = ''

                                if (this.chartPartnersButton) {
                                    this.topChartLineData = Object.assign({}, this.chartStatistics[type + '_partner'])
                                    this.selectedTopType = type + '_partner'
                                } else if (this.chartWithPartnersButton) {
                                    this.topChartLineData = Object.assign({}, this.chartStatistics[type + '_all'])
                                    this.selectedTopType = type + '_all'
                                }
                                else {
                                    this.topChartLineData = Object.assign({}, this.chartStatistics[type])
                                    this.selectedTopType = type
                                }

                                if (item.type == 'top_supplies' || item.type == 'top_bids') {
                                    this.topChartOptions = Object.assign({}, this.optionsTopChartLine)
                                } else {
                                    this.topChartOptions = Object.assign({}, this.optionsTopChartLineMoney)
                                }
                            }, 500)
                        })
                    }
                })
            },
            toggleTopChartByWithPartner() {
                this.chartWithPartnersButton = !this.chartWithPartnersButton
                this.chartPartnersButton = false
                this.handlerTopChartLineData(this.selectedTopTypeParent.index, this.selectedTopTypeParent.type)
            },
            toggleTopChartByPartner() {
                this.chartPartnersButton = !this.chartPartnersButton
                this.chartWithPartnersButton = false
                this.handlerTopChartLineData(this.selectedTopTypeParent.index, this.selectedTopTypeParent.type)
            },
            handlerStatisticsOutputDate(activeIndex, period) {
				this.greenFilterMenu.forEach((item, index) => {
                    item.active = false
                    this.periodButtonActive = false
                    if (activeIndex == index) {
                        item.active = true
						switch (period) {
							case 'today':
								this.period_start = this.$moment.utc().local().format('YYYY-MM-DD') //текущая дата
                                this.period_end = ''
                                this.getStatisticsData();
								break;
							case 'week':
								var now = this.$moment();
								var monday = now.clone().weekday(0);
								this.period_start = monday.format('YYYY-MM-DD') //первый день недели
                                this.period_end = ''
								this.getStatisticsData();
								break;
							case 'month':
								let startOfMonth = this.$moment().startOf('month').format('YYYY-MM-DD');
								this.period_start = startOfMonth //первый день месяца
                                this.period_end = ''
								this.getStatisticsData();
								break;
							case 'year':
								let startOfYear = this.$moment().startOf('year').format('YYYY-MM-DD');
								this.period_start = startOfYear //первый день года
                                this.period_end = ''
								this.getStatisticsData();
								break;
						}
                    }
                })
            },
            getStatisticsData() {
                this.dataOverlay = true
                let byOtdel = ''
                if (this.isManager) {
                    this.creator_user_id = this.currentUser.id
                } else if (!this.isCelebrity) {
                    byOtdel = '&byotdel=1'
                }

                this.routeGetParamChangeOnFly({
                    period_start: this.period_start,
                    period_end: this.period_end
                })

                api.call("get", API_STATISTIC + `?period_start=${this.period_start}&period_end=${this.period_end}&creator_user_id=${this.creator_user_id}${byOtdel}`)
                    .then(({data}) => {
                        this.dataOverlay = false

                        this.suppliesAppendsForCards = initialSuppliesAppendedData()
                        this.cardStatistics = data.cards_numbers
                        this.chartStatistics = data.charts_numbers
                        if (this.chartStatistics.top_supplies) {
                            this.cleanCompanyNames(this.chartStatistics.top_bids.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_supplies.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_earnings.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_debt_buyers.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_bids_partner.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_supplies_partner.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_earnings_partner.datasets)
                            this.cleanCompanyNames(this.chartStatistics.top_debt_buyers_partner.datasets)
                            this.handlerChartColumnData(1, 'bids')
                            this.handlerChartLineData(this.selectedFinanceChartIndex, this.selectedFinanceChartType)
                            this.handlerTopChartLineData(this.selectedTopTypeParent.index, this.selectedTopTypeParent.type)
                        }

                        if (!this.isManager) {
                            this.managerRatingStatistics.items = data.table_numbers.items ? data.table_numbers.items : []
                            this.managerRatingStatistics.fields = data.table_numbers.fields ? data.table_numbers.fields : []

                            if (this.managerRatingStatistics.items && this.managerRatingStatistics.items.length > 0) {
                                this.managerRatingStatistics.items.forEach((item, index) => {
                                    item.realIndex = index
                                })
                            }
                        }

                        this.cbr = data.cbr
                        this.handlerStatisticsData()
                        this.appendStatisticsData(API_ANALYTICS_NEW_LEADS, 'leads')
                        this.appendStatisticsData(API_ANALYTICS_NEW_BIDS, 'bids')
                        this.appendStatisticsData(API_ANALYTICS_BIDS_IN_WORK_PERIOD, 'bids_in_work_period')
                        this.appendStatisticsData(API_ANALYTICS_BIDS_IN_WORK, 'bids_in_work')
                        this.appendStatisticsData(API_ANALYTICS_NEW_SUPPLIES, 'supplies')
                        this.appendStatisticsData(API_ANALYTICS_SUPPLIES_IN_WORK, 'supplies_in_work')
                        this.appendStatisticsData(API_ANALYTICS_SUPPLIES_SUCCESS, 'supplies_in_success')
                        this.appendStatisticsData(API_ANALYTICS_SUPPLIES_FINALIZED, 'supplies_in_finalized')
                        this.appendStatisticsData(API_ANALYTICS_SUPPLIES_IN_CANCEL, 'supplies_in_cancel')
                        this.appendStatisticsData(API_ANALYTICS_BIDS_IN_CANCEL, 'bids_in_cancel')
                        this.appendStatisticsData(API_ANALYTICS_DEBT_OF_BUYERS_7_DAYS, 'debt_of_buyers_7_days')

                        this.userFilterByOtdel = 'all'
                    });
            },
            appendStatisticsData: async function(apiType, loaderType) {
                let loaderIndex = -1

                if (!this.creator_user_id) {
                    loaderIndex = this.managerRatingStatistics.fields.findIndex((element) => {
                        return element.key == loaderType;
                    })

                    if (loaderIndex != -1) {
                        this.managerRatingStatistics.fields[loaderIndex].loading = true
                    }
                }

                let byOtdel = ''
                if (this.isManager) {
                    this.creator_user_id = this.currentUser.id
                } else if (!this.isCelebrity) {
                    byOtdel = '&byotdel=1'
                }

                await api.call("get", apiType + `?period_start=${this.period_start}&period_end=${this.period_end}&creator_user_id=${this.creator_user_id}${byOtdel}`).then(({data}) => {
                    if (loaderType == 'debt_of_buyers_7_days') {
                        this.$set(this.largeCardsRowTwo, 5, data)
                    } else {
                        this.suppliesAppendsForCards[loaderType] = {
                            all_orders_count: data.all_orders_count,
                            all_orders_ids: data.all_orders_ids,
                        }

                        if (!this.creator_user_id) {
                            this.managerRatingStatistics.items.forEach((item, i_index) => {
                                let rowIndex = -1

                                rowIndex = data.orders_by_users.findIndex((user, u_index) => {
                                    return user.id == item.id
                                })

                                if (rowIndex != -1) {
                                    item[loaderType] = data.orders_by_users[rowIndex].orders_count
                                    this.apendedNumbersForTable[loaderType][i_index] = data.orders_by_users[rowIndex].order_ids
                                }
                            })

                            this.prepareNumbersForFiredUsers(data, loaderType)

                            if (loaderIndex != -1) {
                                this.managerRatingStatistics.fields[loaderIndex].loading = false
                            }
                        }

                        this.userFilterByOtdel = 'all'
                    }
                });
            },

            // Prepare for Fired users
            prepareNumbersForFiredUsers(data, loaderType) {
                let rowIndex = this.managerRatingStatistics.items.findIndex((user) => {
                    return user.fired == 1
                })

                if (rowIndex != -1) {
                    let rowIndexPrepared = data.orders_by_users.findIndex((user) => {
                        return user.fired == 1
                    })
                    this.managerRatingStatistics.items[rowIndex]['id'] = ""
                    this.managerRatingStatistics.items[rowIndex][loaderType] = data.orders_by_users[rowIndexPrepared].orders_count
                    this.apendedNumbersForTable[loaderType][rowIndex] = data.orders_by_users[rowIndexPrepared].order_ids
                }
            },
            handlerStatisticsData() {
				let arrData = this.cardStatistics
				let arrLargeCardsRowTwoItem = []
				let arrLargeCardsRowOneItem = []
				for(let item in arrData) {
					if(item == 'paid_to_suppliers' || item == 'finance_bills' || item == 'finance_bills_to_suppliers' || item == 'debt_of_buyers' || item == 'debt_of_buyers_7_days' || item == 'debt_to_suppliers' || item == 'finance_realization'){
						arrLargeCardsRowTwoItem.push(arrData[item])
					}else{
						arrLargeCardsRowOneItem.push(arrData[item])
					}
				}
				this.largeCardsRowOne = arrLargeCardsRowOneItem
				this.largeCardsRowTwo = arrLargeCardsRowTwoItem
			},
            clearActive() {
                this.greenFilterMenu.forEach((item, index) => {
                    item.active = false
                })
                this.periodButtonActive = true
            },
            showByIds(ids, type = 'orders', label = 'Список', order_to_manager = null) {
                label = label.replace('Заявки в работе накоп.', 'Заявки в работе накопительные')

                if (type == 'orders') {
                    this.orderList = ids
                    this.orderListLabel = label
                    this.openOrderList = true
                }
                if (type == 'finance') {
                    this.order_to_manager = order_to_manager;
                    this.financeList = ids
                    this.financeListLabel = label
                    this.openFinanceList = true
                }
                if (type == 'financeGroupedByOrder') {
                    this.financeList = ids
                    this.financeListLabel = label
                    this.openFinanceList = true
                    this.openFinanceGroupedByOrder = true
                }
                if (type == 'dogovors') {
                    this.documentsList = ids
                    this.documentsListLabel = label
                    this.openDocumentsList = true
                }
            },
            // operation: {key: key, type: typeToOpen}
            showByIdsWithPrepare(operation, index, label = 'Список') {
                let ids = this.apendedNumbersForTable[operation.key][index]
                this.showByIds(ids, operation.type, label)
            },
            closeOrderList() {
                this.orderList = []
                this.openOrderList = false
            },
            closeFinanceList() {
                this.financeList = []
                this.openFinanceList = false
                this.openFinanceGroupedByOrder = false
            },
            closeDocumentsList() {
                this.documentsList = []
                this.openDocumentsList = false
            },
            sumByColumn(columnName) {
                let sum = 0
                let notZeroUsers = 0    // users without zeros in numbers

                let formatter = new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })

                this.filteringDataByGroupFilter.forEach((manager, index) => {
                    sum += manager[columnName]
                    if (manager[columnName] > 0) {
                        notZeroUsers++
                    }
                })

                switch (columnName) {
                    case 'dogovors':
                        sum = sum
                        break;
                    case 'marginality':
                        sum = formatter.format(sum / notZeroUsers)
                        break;
                    default:
                        sum = formatter.format(sum)
                }


                return sum
            },
            generateExcelList() {
                this.generatingUrlProcess = true
                this.generatedUrl = ''

                let byOtdel = 0
                if (!this.isManager && !this.isCelebrity) {
                    byOtdel = 1
                }

                const companyIds = this.collectCompanyIdsForExcelExport()

                api.call(
                    "post",
                    API_TOP_COMPANIES_EXCEL_ENRICHMENT,
                    {
                        period_start: this.period_start,
                        period_end: this.period_end,
                        creator_user_id: this.creator_user_id,
                        byotdel: byOtdel,
                        company_ids: companyIds
                    }
                )
                    .then(({data}) => {
                        const managers = data.managers || {}
                        const dataForExport = {
                            sheets: [
                                this.prepareDataForExcel('top_bids', managers),
                                this.prepareDataForExcel('top_supplies', managers),
                                this.prepareDataForExcel('top_earnings', managers),
                                this.prepareDataForExcel('top_debt_buyers', managers),
                                this.prepareGrossProfitSheet(data, managers)
                            ]
                        }
                        this.reportGenerateUrl(dataForExport)
                    })
                    .catch(() => {
                        this.generatingUrlProcess = false
                    })
            },
            collectCompanyIdsForExcelExport() {
                const ids = {}
                const types = ['top_bids', 'top_supplies', 'top_earnings', 'top_debt_buyers']
                types.forEach((baseType) => {
                    let type = baseType
                    if (this.chartPartnersButton) {
                        type = type + '_partner'
                    } else if (this.chartWithPartnersButton) {
                        type = type + '_all'
                    }
                    const list = this.chartStatistics[type] && this.chartStatistics[type].fullList
                        ? this.chartStatistics[type].fullList
                        : []
                    list.forEach((item) => {
                        if (item && item.id) {
                            ids[item.id] = true
                        }
                    })
                })
                return Object.keys(ids)
            },
            prepareGrossProfitSheet(enrichment, managers) {
                let type = 'top_gross_profit'
                if (this.chartPartnersButton) {
                    type = type + '_partner'
                } else if (this.chartWithPartnersButton) {
                    type = type + '_all'
                }

                const block = enrichment[type] || { labels: [], fullList: [] }
                const dataForExport = {
                    settings: {
                        title: this.generateTitle(type),
                        sheet_title: 'Прибыль'
                    },
                    headers: this.generateHeaders(block.labels || [], this.chartPartnersButton, this.chartWithPartnersButton),
                    items: []
                }
                dataForExport.items = this.generateItems(
                    this.applyManagersToItems(block.fullList || [], managers),
                    dataForExport.headers,
                    type
                )
                return dataForExport
            },
            applyManagersToItems(items, managers) {
                if (this.chartPartnersButton || !managers) {
                    return items
                }
                return items.map((item) => {
                    const manager = managers[item.id]
                    if (!manager) {
                        return item
                    }
                    return Object.assign({}, item, {
                        sales_manager: manager.sales_manager,
                        to_manager: manager.to_manager,
                        teo_manager: manager.teo_manager
                    })
                })
            },
            prepareDataForExcel(type, managers = {}) {
                if (this.chartPartnersButton) {
                    type = type + '_partner'
                }

                const dataForExport = {
                    "settings": {
                        "title": this.generateTitle(type),
                        "sheet_title": this.generateSheetTitle(type)
                    },
                    "headers": {},
                    "items": []
                }

                if (this.chartWithPartnersButton) {
                    type = type + '_all'
                }

                const block = this.chartStatistics[type] || { labels: [], fullList: [] }
                dataForExport.headers = this.generateHeaders(block.labels || [], this.chartPartnersButton, this.chartWithPartnersButton)
                dataForExport.items = this.generateItems(
                    this.applyManagersToItems(block.fullList || [], managers),
                    dataForExport.headers,
                    type
                )

                return dataForExport
            },
            canSeeUserFilters() {
                if (this.currentUser.role.includes("president") || this.currentUser.role.includes("administrator") || this.currentUser.role.includes("head-accountant")) {
                    return true
                }
                return false
            },
            tdColorist(key) {
                switch (key) {
                    case 'supplies_in_work':
                        return 'td-work-span '
                        break;
                    case 'bids_in_work_period':
                    case 'bids_in_work':
                        return 'td-work-span '
                        break;
                    case 'supplies_in_success':
                        return 'td-success-span '
                        break;
                    case 'supplies_in_finalized':
                        return 'td-success-span '
                        break;
                    default:
                        return ''
                }
            },
            canClickOnNumberInTable(key) {
                switch (key) {
                    case 'leads':
                    case 'bids':
                    case 'bids_in_work_period':
                    case 'bids_in_work':
                    case 'supplies':
                    case 'supplies_in_work':
                    case 'supplies_in_success':
                    case 'supplies_in_finalized':
                    case 'supplies_in_cancel':
                    case 'bids_in_cancel':
                        return {
                            key: key,
                            type: 'orders'
                        }
                        break;
                    default:
                        return ''
                }
            },
            cleanCompanyNames(companies) {
                companies.forEach((company) => {
                    try {
                        company.label = company.label.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, "")
                        company.label = company.label.match(/(?:«[^«]*»|^[^»]*$)/)[0].replace(/«/g, "").replace(/»/g, "")
                        company.label = company.label.replace("Партнер. ", "")
                    } catch (error) {
                        company.label = "Неизвестно имя #" + company.id;
                    }
                })
            },
        },
    };
</script>
<style scoped>
    .underline-dotted {
        border-bottom: 1px dashed #999999;
    }
    .cursor-pointer:hover .underline-dotted,
    .underline-dotted:hover {
        border-bottom: 1px dashed transparent;
    }
    .hide-button {
        display: none !important;
    }
</style>
